
import { useNavigate, type NavigateFunction } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { useEffect } from "react";
import routes from "./config";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

// 간단한 인증 확인 함수
const checkAuth = () => {
  try {
    const userStr = sessionStorage.getItem('user');
    if (!userStr) return false;
    
    const user = JSON.parse(userStr);
    return user.authenticated === true;
  } catch {
    return false;
  }
};

// 개발자 도구 차단 (간단한 방법)
const blockDevTools = () => {
  // 우클릭 방지
  document.addEventListener('contextmenu', (e) => e.preventDefault());
  
  // 텍스트 선택 방지
  document.addEventListener('selectstart', (e) => e.preventDefault());
  
  // 주요 단축키 차단
  document.addEventListener('keydown', (e) => {
    // F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U
    if (
      e.key === 'F12' ||
      (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'J' || e.key === 'C')) ||
      (e.ctrlKey && e.key === 'u')
    ) {
      e.preventDefault();
      return false;
    }
  });
};

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();
  
  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
    
    // 개발자 도구 차단 적용
    blockDevTools();
    
    // 간단한 인증 확인
    const currentPath = window.location.pathname;
    const basePath = __BASE_PATH__ || '';
    const isLoginPage = currentPath === '/' || 
                       currentPath === basePath || 
                       currentPath === `${basePath}/` ||
                       currentPath.includes('/login');
    
    if (!isLoginPage && !checkAuth()) {
      navigate('/', { replace: true });
    }
  }, [navigate]);

  return element;
}
